import { render, staticRenderFns } from "./ProblemFeedback.vue?vue&type=template&id=63c21762&scoped=true&"
import script from "./ProblemFeedback.vue?vue&type=script&lang=js&"
export * from "./ProblemFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ProblemFeedback.vue?vue&type=style&index=0&id=63c21762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c21762",
  null
  
)

export default component.exports